export default __webpack_public_path__ + "static/media/img-slider-cmbus-admin-2.90065e61.png";